<script setup lang="ts">
import IconInformation from '~icons/mdi/information-outline'

const userStore = useUserStore()
const localePath = useLocalePath()

const isVisible = computed(() =>
  userStore.isAuthenticated
  && userStore.data
  && !userStore.data.pharmacyRegistrationCertificateKey,
)
</script>

<template>
  <div v-if="isVisible" class="pharmacy-banner-wrapper py-2">
    <v-container class="d-flex align-center pa-0">
      <v-icon
        :icon="IconInformation"
        color="#FFA600"
        class="mr-3"
        size="32"
      />
      <span class="pharmacy-banner-text text-body-1 mr-4">
        {{ $t('layout.pharmacyBanner.text') }}
      </span>
      <v-btn
        color="#FFA600"
        variant="flat"
        size="small"
        rounded="lg"
        class="text-white font-weight-bold text-body-2 ml-4"
        :to="localePath('/account/profile')"
      >
        {{ $t('layout.pharmacyBanner.action') }}
      </v-btn>
    </v-container>
  </div>
</template>

<style scoped>
.pharmacy-banner-wrapper {
  background-color: #FFEED6;
  position: sticky;
  top: 136px;
  z-index: 99;
}
.pharmacy-banner-text {
  color: #FFA600;
}
</style>
